module.exports = __webpack_public_path__ + "img/3.b4d5cd25.jpg";